/**
 * listenGate — whether the thread store listens to a thread's reactions.
 *
 * The overlay's rule (fail-open on unknown membership, shared threads only)
 * left SOLO threads without a listener, so a reaction written there lived in
 * the optimistic overlay alone and vanished on reload (2026-09-09). A solo
 * thread that carries a registry row (the membership read returns one for
 * every thread the caller participates in) listens too — the rules admit its
 * owner, and that is where its reactions come back from.
 */
export interface ReactionListenGateArgs {
  threadId: string | null | undefined;
  /** Threads with ≥ 2 registered humans; null = membership unknown (fail open). */
  sharedThreadIds?: ReadonlySet<string> | null;
  /** The server-owned index marker for a just-shared thread. */
  activeThreadMarkedShared?: boolean;
  /** Every thread the membership read returned a row for (solo rows included). */
  registeredThreadIds?: ReadonlySet<string> | null;
}

export function shouldListenForReactions(args: ReactionListenGateArgs): boolean {
  const id = (args.threadId ?? '').trim();
  if (!id) return false;
  if (args.activeThreadMarkedShared) return true;
  if (!args.sharedThreadIds) return true;
  if (args.sharedThreadIds.has(id)) return true;
  return !!args.registeredThreadIds?.has(id);
}
